import { render, staticRenderFns } from "./coleta-exames.vue?vue&type=template&id=590a1077&"
import script from "./coleta-exames.vue?vue&type=script&lang=js&"
export * from "./coleta-exames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports